import {
  ExperienceRating,
  ExperienceRatingPayload,
} from 'types/experience/experience-rating.type';
import { PaginatedResponse, PaginationQueries } from 'types/search.type';
import { client } from 'utils/axios';

class ExperienceRatingService {
  async getExperienceRatings(
    experienceId: number,
    pagination: PaginationQueries
  ): Promise<PaginatedResponse<ExperienceRating[]>> {
    const { data } = await client.get(
      `/v1/customer/rating/experience/${experienceId}/comments`,
      {
        params: {
          ...pagination,
        },
      }
    );
    return data;
  }

  async rateExperience(payload: ExperienceRatingPayload): Promise<void> {
    return await client.post('/v1/customer/rating/experience', payload);
  }
}

export const experienceRatingService = new ExperienceRatingService();
